import AdminShell from "@/components/admin/AdminShell";
import { SalesInbox } from "@/components/outreach/SalesInbox";

export default function SalesInboxPage() {
  return (
    <AdminShell title="Sales Inbox" subtitle="Every campaign reply sent to sales@mynextbigmove.co, in one place. Anyone on the team can read and answer, and replies go out as sales@.">
      <SalesInbox />
    </AdminShell>
  );
}
